export const HEADER_BLOCK_S02 =  {
  "blockType": "HEADER",
  "blockDesign": "header_01",
  "styleProps": {
    "background-image": "url('')",
    "background-color": "#ffffff",
    "padding": "120px 20px 120px 20px"
  },
  "position": "center",
  "headingsStyleProps": {
    "padding": "10px 0px 10px 0px",
    "text-align": "center"
  },
  "headingsStylePropsTab": {
    "padding": "10px 0px 10px 0px"
  },
  "headingsStylePropsMob": {
    "padding": "10px 0px 10px 0px"
  },
  "headings": [
    {
      "styleProps": {
        "font-size": "3.75rem",
        "line-height": "1",
        "padding": "20px 0px 40px 0px",
        "font-weight": "400",
        "color": "#333333",
        "font-family-cust": "Playfair Display",
        "font-family": "'Playfair Display'",
        "margin": "0px 0px 0px 0px",
        "font-family-bk": "'Playfair Display', serif"
      },
      "stylePropsTab": {
        "font-size": "3rem",
        "line-height": "1",
        "padding": "20px 0px 20px 0px"
      },
      "stylePropsMob": {
        "font-size": "2.25rem",
        "line-height": "2.5rem",
        "padding": "20px 0px 20px 0px"
      },
      "text": "Transforming Businesses with Innovative Software Solutions"
    },
    {
      "text": "Empowering growth, efficiency, and success through cutting-edge technology",
      "styleProps": {
        "font-size": "1.125rem",
        "line-height": "1.75rem",
        "color": "#333333",
        "margin": "0px 0px 40px 0px"
      }
    }
  ],
  "dynamicText": {
    "styleProps": {
      "font-size": "1.875rem",
      "line-height": "2.25rem",
      "padding": "10px 0px 10px 0px",
      "text-align": "center"
    },
    "stylePropsTab": {
      "padding": "10px 0px 10px 0px"
    },
    "stylePropsMob": {
      "padding": "10px 0px 10px 0px"
    },
    "strings": []
  },
  "descriptionsStyleProps": {
    "padding": "10px 0px 10px 0px",
    "text-align": "center"
  },
  "descriptionsStylePropsTab": {
    "padding": "10px 0px 10px 0px"
  },
  "descriptionsStylePropsMob": {
    "padding": "10px 0px 10px 0px"
  },
  "descriptions": [
    {
      "text": "✸ 4.97/5 from over 400 reviews",
      "styleProps": {
        "font-size": "1.125rem",
        "line-height": "1.75rem",
        "color": "#333333",
        "font-weight": "500"
      }
    }
  ],
  "buttonsStyleProps": {},
  "buttons": [],
  "emailSecStyleProps": {},
  "subscription": {
    "showSection": "hide",
    "display": "enable",
    "subConfigs": {
      "configType": "convertkit",
      "configUrl": "https://app.convertkit.com/forms/xxxxxx/subscriptions",
      "configPlaceholder": ""
    },
    "email_placeholder": {
      "text": "example@mail.com"
    },
    "buttonText": {
      "text": "Subscribe",
      "styleProps": {
        "background-color": "#1b1b31",
        "color": "#ffffff"
      }
    },
    "successMessage": {
      "text": "Thank you for the signup",
      "styleProps": {}
    },
    "errorMessage": {
      "text": "Something went wrong. Please try again.",
      "styleProps": {}
    }
  },
  "textsStyleProps": {
    "text-align": "center"
  },
  "texts": [
    {
      "type": "el",
      "sub_type": "html",
      "text": "Want to use a web browser? <a href='#'>Log in to Gusto</a>"
    }
  ],
  "editFormName": "HEADER_FORM_01",
  "metaDataId": 1745672248905,
  "afterIndex": -1,
  "blockId": 1745672248905,
  "textBlock": {
    "descriptions": [
      {
        "text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        "styleProps": {
          "font-size": "1.125rem",
          "line-height": "1.75rem",
          "color": "#ffffff"
        }
      },
      {
        "text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        "styleProps": {
          "font-size": "1.125rem",
          "line-height": "1.75rem",
          "color": "#ffffff"
        }
      }
    ],
    "headings": [
      {},
      {}
    ]
  },
  "fonts": {
    "headings": [
      "Playfair Display"
    ]
  },
  "stylePropsMob": {
    "padding": "60px 14px 60px 14px"
  },
  "stylePropsTab": {
    "padding": "80px 20px 80px 20px"
  }
}